import React, { useState, useEffect } from 'react';
import { Box, Stack, Typography, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { paths } from 'routes';
import { KanbanCard } from './KanbanCard';
import { getStatus } from '../../utils/getStatus';
import { Search } from 'components/Search';
import { Add } from '../Add';
import { useAuth } from 'lib/auth';
import { Loader } from 'components/Loader';

export const MyAdsKanban = ({ jobAds = [], isFetching, handleSearchChange, refetch, filters }) => {
  const { account, user } = useAuth();
  const companyID = account.super_admin ? -1 : user?.Company?.Type === 'supplier' ? user?.Company?.company_id : 0;
  
  const [kanbanColumns, setKanbanColumns] = useState({
    draft: { name: 'DRAFT', items: [] },
    active: { name: 'ACTIVE', items: [] },
    ended: { name: 'ENDED', items: [] },
  });

  useEffect(() => {
    const adsByStatus = jobAds.reduce((acc, ad) => {
      const status = getStatus(ad);
      if (!acc[status]) {
        acc[status] = [];
      }
      acc[status].push(ad);
      return acc;
    }, {});

    const sortAds = (ads) => {
      return ads.sort((a, b) => new Date(a.last_day_to_respond) - new Date(b.last_day_to_respond));
    };

    setKanbanColumns({
      draft: { name: 'DRAFT', items: sortAds(adsByStatus.draft || []) },
      active: { name: 'ACTIVE', items: sortAds(adsByStatus.active || []) },
      ended: { name: 'ENDED', items: sortAds(adsByStatus.ended || []) },
    });
  }, [jobAds]);

  return (
    <Stack
      px={4}
      py={2}
      bgcolor="background.paper"
      borderTop="1px solid"
      borderColor="border.main"
    >
      <Stack direction="row" gap={2} alignItems="center">
        <Search handleSearchChange={handleSearchChange} sx={{ minWidth: 200, width: 270, flexShrink: 0 }} />
        {filters}
        {!account.super_admin && user?.Company?.Type === 'supplier' && (
          <Box ml="auto" flexShrink={0}>
            <Add refetch={refetch} companyID={companyID} user={user} />
          </Box>
        )}
      </Stack>
      {isFetching ? (
        <Loader />
      ) : (
      <Stack direction="row" spacing={2} p={2} width="100%" boxSizing={'border-box'}>
        {Object.entries(kanbanColumns).map(([columnId, column]) => (
          <Paper
            key={columnId}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              bgcolor: '#fdfdfd',
              p: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                p: 1,
                textAlign: 'center',
                borderBottom: '1px solid',
                borderColor: 'divider',
                pb: 1,
              }}
            >
              {column.name}
            </Typography>
            <Stack spacing={1} mt={2}>
              {column.items.map((item) => (
                <Link
                  key={item.ad_id}
                  component={RouterLink}
                  to={`${paths.myJobAdsDetailsView(item.ad_id)}`}
                  color="inherit"
                  underline="none"
                >
                  <KanbanCard {...item} />
                </Link>
              ))}
            </Stack>
          </Paper>
        ))}
      </Stack>
      )}
    </Stack>
  );
};